import {
  Box,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material';

export default function QuestionStep({
  question,
  questionNumber,
  selectedOption,
  onSelect,
}) {
  if (!question) return null;

  return (
    <Box sx={{ px: 1 }}>
      <Typography variant="body1" fontWeight={500} sx={{ mb: 3 }}>
        {questionNumber}. {question.question}
      </Typography>
      <RadioGroup
        value={selectedOption ?? ''}
        onChange={(e) => onSelect(Number(e.target.value))}
        sx={{ pl: 1 }}
      >
        {question.alternatives.map((alt) => (
          <FormControlLabel
            key={alt.option}
            value={alt.option}
            label={alt.text}
            control={<Radio color="primary" />}
            sx={{ mb: 1 }}
          />
        ))}
      </RadioGroup>
    </Box>
  );
}
